import Modal from "./Modal";
import { FiMenu, FiX } from "react-icons/fi";
import { ReactComponent as Logo } from '../assets/logoHo.svg';
import { useState } from "react";
import { Link } from "react-scroll";
import useModal from "../hooks/useModal";
import Manual from "../assets/manual_loginem.pdf";

const Header = () => {
  const activo = "underline decoration-sky-700 decoration-2 underline-offset-4";
  const { open, close, isOpen } = useModal();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const navItems = (
    <>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="inicio" smooth={true} duration={500}>Inicio</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="servicios" smooth={true} duration={500}>Servicios</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="solicitar" smooth={true} duration={500}>Cotización</Link>
      <Link onClick={closeMenu} className="cursor-pointer" activeClass={activo} spy={true} to="contactanos" smooth={true} duration={500}>Contacto</Link>
      <button onClick={() => { open(); closeMenu(); }} className="hover:underline decoration-sky-400 decoration-2 underline-offset-4">
        Manual de procedimientos
      </button>
    </>
  );

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white shadow px-4 py-3 flex justify-between items-center">
      <Logo className="w-auto h-12"/>
      <nav className="hidden md:flex gap-6 text-sm font-medium">
        {navItems}
      </nav>
      <div className="md:hidden">
        <button onClick={toggleMenu} aria-label="Toggle Menu">
          {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </button>
      </div>
      {menuOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-md flex flex-col items-start gap-4 p-4 text-sm font-medium z-40">
          {navItems}
        </div>
      )}
      {isOpen && (
        <Modal title="Manual organizacional" onClose={close}>
          <iframe src={Manual} className="w-full h-[65vh]" title="Manual org. y de procedimientos" />
        </Modal>
      )}
    </header>
  );
};

export default Header;